import { Pipe, PipeTransform } from "@angular/core";
import SkillRating, {
  skillRatingToString,
} from "@skills-app/models/skillRating";

@Pipe({
  standalone: false,
  name: "skillAndRatingDisplay",
})
export class SkillAndRatingDisplayPipe implements PipeTransform {
  transform(
    skill: { Name: string; SkillRating: SkillRating } | null | undefined,
  ): string {
    if (!skill) return "";
    return `${skill.Name} | ${skillRatingToString(skill.SkillRating)}`;
  }
}
